import { observer } from "mobx-react-lite";
import { ModalStore } from "@root/stores/modalStore";
import { EventView } from "@root/pages/index/components/EventView";
import { ViewOrganizationModal } from "@root/components/modals/ViewOrganizationModal";
import { Dialog, DialogContent } from "@mui/material";
import { Event, Organization } from "@root/utils/entities";
import { APP_MODAL_MAX_WIDTH } from "./modalConstants";
import { useState } from "react";

type ViewEventModalProps = {
  event?: Event;
  store: ModalStore;
  onClose: () => void;
  viewOrganization: (organization: Organization) => void;
  onFollowChange?: (isFollowed: boolean) => void;
  onHideChange?: (eventId: string, isHidden: boolean) => void;
};

export const ViewEventModal = observer(
  ({
    event,
    store,
    onClose,
    viewOrganization,
    onViewEvent,
    onFollowChange,
    onHideChange,
  }: ViewEventModalProps & { onViewEvent: (event: Event) => void }) => {
    const [vendorOrganizationModalStore] = useState(() => new ModalStore());
    const [venueOrganizationModalStore] = useState(() => new ModalStore());
    const [vendorOrganization, setVendorOrganization] = useState<
      Organization | undefined
    >(undefined);
    const [venueOrganization, setVenueOrganization] = useState<
      Organization | undefined
    >(undefined);
    const [reopenVendorsListToken, setReopenVendorsListToken] = useState(0);

    if (!event) return null;

    const openOrganization = (
      organization: Organization,
      fromVendorsList?: boolean,
      fromVenue?: boolean,
    ) => {
      if (fromVenue) {
        setVenueOrganization(organization);
        venueOrganizationModalStore.open();
        return;
      }
      if (fromVendorsList) {
        setVendorOrganization(organization);
        vendorOrganizationModalStore.open();
        return;
      }
      viewOrganization(organization);
    };

    return (
      <>
        <Dialog
          open={store.isOpen}
          onClose={onClose}
          fullWidth={true}
          disableScrollLock={true}
          PaperProps={{
            sx: {
              borderRadius: "1rem",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
              maxWidth: APP_MODAL_MAX_WIDTH,
              width: "100%",
            },
          }}
        >
          <DialogContent
            sx={(theme) => ({
              backgroundColor: theme.palette.background.paper,
              padding: 0,
            })}
          >
            <EventView
              event={event}
              onOrganizationClick={openOrganization}
              onClose={onClose}
              onFollowChange={onFollowChange}
              onHideChange={onHideChange}
              reopenVendorsListToken={reopenVendorsListToken}
            />
          </DialogContent>
        </Dialog>
        {vendorOrganization && (
          <ViewOrganizationModal
            store={vendorOrganizationModalStore}
            organization={vendorOrganization}
            onClose={() => {
              vendorOrganizationModalStore.close();
              setVendorOrganization(undefined);
            }}
            onBack={() => {
              vendorOrganizationModalStore.close();
              setVendorOrganization(undefined);
              setReopenVendorsListToken((value) => value + 1);
            }}
            onViewEvent={(event) => {
              vendorOrganizationModalStore.close();
              setVendorOrganization(undefined);
              onViewEvent(event);
            }}
          />
        )}
        {venueOrganization && (
          <ViewOrganizationModal
            store={venueOrganizationModalStore}
            organization={venueOrganization}
            onClose={() => {
              venueOrganizationModalStore.close();
              setVenueOrganization(undefined);
            }}
            onBack={() => {
              venueOrganizationModalStore.close();
              setVenueOrganization(undefined);
            }}
            onViewEvent={(event) => {
              venueOrganizationModalStore.close();
              setVenueOrganization(undefined);
              onViewEvent(event);
            }}
          />
        )}
      </>
    );
  },
);
